/*
* Tools for manipulating measured time
*/
define('utils/time',[],
function() {
  return {
    local: function(format) {
      if (format == 'unix') {
        if (!Date.now) {
          Date.now = function() { return new Date().getTime(); };
        }

        return Math.floor(Date.now() / 1000);
      }
    }
  };
});

